import { render, staticRenderFns } from "./OfferBottomBar.vue?vue&type=template&id=4b15a3d6&scoped=true"
import script from "./OfferBottomBar.vue?vue&type=script&lang=ts"
export * from "./OfferBottomBar.vue?vue&type=script&lang=ts"
import style0 from "./OfferBottomBar.vue?vue&type=style&index=0&id=4b15a3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b15a3d6",
  null
  
)

export default component.exports